<template>
  <div>
    <el-row>
      <el-col>
        <el-col>
          <el-table :data="tableData" border stripe style="margin-top: 20px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="BATCH" label="产品批次"></el-table-column>
            <el-table-column prop="LOCATION_CODE" label="库位" v-if="warehouseMode == 2"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="价格"></el-table-column>
            <!-- <el-table-column prop="BEFORE_TAX_PRICE" label="不含税价格" min-width="45"></el-table-column> -->
            <!-- <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column> -->
            <el-table-column prop="PRODUCT_COUNT" label="退货数量"></el-table-column>
            <el-table-column prop="COMMENT" label="退货原因"></el-table-column>
            <el-table-column prop="USER_NAME" label="操作人"></el-table-column>
            <el-table-column prop="OPERATION_TIME" label="操作时间"></el-table-column>
          </el-table>
        </el-col>
      </el-col>
      <el-col>
        <el-button @click="toPrintTable" style="float: right;margin-top: 10px">打印</el-button>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { print } from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      titleData: { ...JSON.parse(sessionStorage.getItem('pickingDocReturnDetailTitle')) },
      companyName: '',
      isDisplay: 'none',
      warehouseMode: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created() {
    this.queryData();
    this.companyName = sessionStorage.getItem('company');
    if (sessionStorage.getItem('tcId') == 4097) {
      this.isDisplay = 'flex';
    }
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '10047',
        OTYPE: 8,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        INNER_ORDER_ID: Number(this.$route.params.id),
        OPERATION_TIME_STAMP: this.titleData.OPERATION_TIME_STAMP,
      };
      http.post(params).then((res) => {
        this.tableData = res.LIST.map((item) => ({ ...item, PRODUCT_FEE: Number(item.PRODUCT_COUNT * item.PRODUCT_PRICE).toFixed(2) }));
        this.titleData = {
          ...this.titleData,
          ...res.TITLE,
        };
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main" >';
      html += `<div class="title">${this.companyName}领料退货单</div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料单ID：${this.titleData.INNER_ORDER_ID}</div><div class="code">领料人：${this.titleData.REQUISITIONER}</div><div>领料部门：${this.titleData.DEPARTMENT_NAME}</div></div>`;
      html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">领料日期：${this.titleData.SEND_DAY}</div></div>`;
      html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
      html += '<tr style="text-align: center"><td style="width: 40px">序号</td><td>产品编码</td> <td>产品</td> <td>单位</td> <td  style="width: 40px">单价</td> <td style="width: 70px">退货数量</td> <td  style="width: 70px">退货金额</td> <td>退货原因</td> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center;font-size: 14px">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_CODE}</td> <td>${item.PRODUCT_NAME}</td><td>${item.TYPE_UNIT}</td><td>${item.PRODUCT_PRICE}</td>
                        <td>${item.PRODUCT_COUNT}</td> <td>${item.PRODUCT_FEE} </td> <td>${item.COMMENT}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += `<div class="divTop" style="font-size:12px; right:1%; flex-direction: column; position:absolute; page-break-after: always; position: fixed;  top: 250px; display:${this.isDisplay}">`;
      html += '<span style="font-size:15px">白</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">财</span>';
      html += '<span style="font-size:15px">务</span>';
      html += '<div style="height:5px;"> </div>';
      html += '<span style="font-size:15px">红</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">存</span>';
      html += '<span style="font-size:15px">根</span>';
      html += '<div style="height:5px;"></div>';
      html += '<span style="font-size:15px">黄</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">领</span>';
      html += '<span style="font-size:15px">料</span>';
      html += '</div>';
      html += '</table>';
      html += `<div class="head" style="margin-top: 20px; flex-direction: Row-Reverse; font-size: 16px;"><div class="code">退货总金额：${this.titleData.PRODUCT_FEE}</div><div class="code">主管：</div><div class="code">退货人：</div></div>`;
      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingDocReturnDetail.vue